import StepRoute from '../classes/step-route.class';
import RouteNames from '../constants/route-names';

const route = new StepRoute(
  RouteNames.NotFound,
  '/oops',
  () => import('@/views/NotFound.vue'),
);

export default route.getRoute();
